export interface TicketMultiLevelPathItem {
  level: number;
  id: number;
  choice: string;
  label: string;
}

export interface TicketMultiLevelValue {
  display?: string;
  path?: TicketMultiLevelPathItem[];
  field_definition_id?: number;
}

function normalizePathString(value: string): string {
  return value
    .split(/>\s*/)
    .map((part) => part.trim())
    .filter(Boolean)
    .join(">");
}

export function getMultiLevelDisplayValue(value: unknown): string | null {
  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    const normalized = normalizePathString(value);
    return normalized || null;
  }

  if (typeof value === "object") {
    const multiLevelValue = value as TicketMultiLevelValue;

    if (typeof multiLevelValue.display === "string") {
      const normalized = normalizePathString(multiLevelValue.display);
      return normalized || null;
    }

    if (Array.isArray(multiLevelValue.path) && multiLevelValue.path.length > 0) {
      return multiLevelValue.path
        .slice()
        .sort((a, b) => a.level - b.level)
        .map((item) => item.choice)
        .join(">");
    }
  }

  return null;
}

export function getMultiLevelTicketPath(value: unknown): TicketMultiLevelPathItem[] | null {
  if (!value || typeof value !== "object") {
    return null;
  }

  const multiLevelValue = value as TicketMultiLevelValue;
  if (!Array.isArray(multiLevelValue.path) || multiLevelValue.path.length === 0) {
    return null;
  }

  return multiLevelValue.path
    .slice()
    .sort((a, b) => a.level - b.level)
    .map((item) => ({
      level: item.level,
      id: item.id,
      choice: item.choice,
      label: item.label,
    }));
}